<div class="twofactor-grid">
    <div class="twofactor-main">
        <div class="twofactor-left">
            <div class="login-pharma-img">
                <span *ngIf="pharmacyLogo"><img alt="Pharmacy" [src]="pharmacyLogo" class="phrmaLogo-bg"></span>
                <span>{{pharmacyInfo?.name}}</span>
                <p *ngIf="pharmacyInfo?.phone">Ph: {{pharmacyInfo?.phone | pharmNumberformat}}</p>
            </div>
            <div class="login-pharma-img laptop">
                <img alt="Pharmacy" src="../assets/images/lapy-img.png">
            </div>
        </div>
        <div class="twofactor-right">
            <div class="title">Two - Factor Verification</div>
            <div class="sub-title">Please enter the two-factor code that was sent to registered mobile number <span class="txt-clr-prpl">
                {{PatientPhoneNo}}
            </span></div>
            <div class="verification-form">
                <form [formGroup]="otpForm">
                    <div class="ver-code">Verification Code</div>
                    <div class="optFrm">
                        <div class="input-boxes" *ngFor="let controlName of ['digit1', 'digit2', 'digit3', 'digit4', 'digit5', 'digit6']; let i = index">
                            <input #input type="text" [formControlName]="controlName" (input)="onInputChange($event, controlName)" maxlength="1" class="input two-fact-mask" [attr.id]="'digit' + (i + 1)"
                            (keydown)="onKeyDown($event, controlName)" [value]="getMaskedValue(controlName)" />
                        </div>
                    </div>
                    <div *ngIf="otpForm.invalid && (otpForm.dirty || otpForm.touched)">
                        <div *ngIf="f.digit1.errors?.required || f.digit2.errors?.required || f.digit3.errors?.required ||
                                    f.digit4.errors?.required || f.digit5.errors?.required || f.digit6.errors?.required">
                        </div>
                    </div>
                    <div *ngIf="invalidOTP && isOtpChanged">
                        <small class="text-danger">Invalid OTP.</small>
                    </div>
                    <button type="button" class="verfity-btn" (click)="validateOTP()" [disabled]="otpForm.invalid" [ngClass]="{'active': !otpForm.invalid, 'disabled': otpForm.invalid}">Verify</button>
                    <div class="text-blue">
                        <a href="javascript:void(0)" class="resend" (click)="resendOTP()">Resend Code</a>
                    </div>
                </form>
            </div>
            <div class="powerd-by">Powered by <img src="../assets/images/login-powerby.svg" alt="Powered by"></div>
        </div>
    </div>
</div>
<div class="copyRight">© Copyright {{currentYear}}. All rights reserved.</div>